// extracted by mini-css-extract-plugin
export var divider = "_gs-7";
export var itemsToggle = "_gs-8";
export var mergeModal = "_gs-1";
export var optionCard = "_gs-4";
export var radioGroup = "_gs-6";
export var radioOption = "_gs-0";
export var selected = "_gs-5";
export var shipmentOptions = "_gs-2";
export var tableOptions = "_gs-3";